<template>
  <GenericStep v-bind="$attrs">
    <PhysicalAddressCard
      class="mb-4"
      :item="peParty.physical_address"
    />

    <MailingAddressCard
      class="mb-4"
      :item="peParty.mailing_address"
    />
  </GenericStep>
</template>

<script>
import { cloneDeep, isEqual } from 'lodash'
import { mapGetters } from 'vuex'

import { PARTY_NAMESPACE } from '@/store/party'

import GenericStep from '@/components/Party/QuickInterview/GenericStep.vue'
import MailingAddressCard from '@/components/Party/PartyEdit/SectionCards/PersonalDataCards/MailingAddressCard.vue'
import PhysicalAddressCard from '@/components/Party/PartyEdit/SectionCards/PersonalDataCards/PhysicalAddressCard.vue'

export default {
  name: 'AddressesStep',

  components: {
    GenericStep,
    MailingAddressCard,
    PhysicalAddressCard,
  },

  inheritAttrs: false,

  data () {
    return {
      hasChanged: false,
      originalData: null,
    }
  },

  computed: {
    relevantFields () {
      return {
        mailing: this.peParty.mailing_address,
        physical: this.peParty.physical_address,
      }
    },

    ...mapGetters(PARTY_NAMESPACE, [
      'peParty',
    ]),
  },

  watch: {
    relevantFields (value) {
      if (!this.hasChanged && !isEqual(value, this.originalData)) {
        this.hasChanged = true
        this.$emit('changed', true)
      }
    },
  },

  created () {
    this.originalData = cloneDeep(this.relevantFields)
  },
}
</script>
